<template>
    <base-notification :notification="notification" :highlight="highlight" :can-read="true">
        <p v-html="notification.data.message"></p>
        <time :datetime="notification.created_at" v-if="showDate">{{ notification.created_at }}</time>
        <router-link :to="notification.data.link" class="btn btn--sm btn--secondary" @click="markAsRead" v-if="notification.data.link && showLink">More</router-link>
    </base-notification>
</template>

<script>
    import BaseNotification from "./BaseNotification";

    export default {
        components: {BaseNotification},
        props: {
            notification: Object,
            showLink: {
                default: true
            },
            showDate: {
                default: true
            },
            highlight: {
                default: true
            }
        },

        methods: {
            markAsRead() {
                if (this.notification.read_at) {
                    return
                }

                axios.post('/notifications/mark-as-read', {
                    id: this.notification.id
                }).then(() => Quiz.$emit('notification-read', this.notification));
            }
        }
    }
</script>

